import './reset.css';
import './stylesheet.css';
import './common.css';
import HeaderButton from './components/header/HeaderButton.jsx';
import Banner from './components/intro/Banner.jsx';
import Section from './components/sections/Section';
import AboutMe from './components/sections/AboutMe.jsx';
import SectionSplit from './components/sections/SectionSplit.jsx';
import MyEducation from './components/sections/education/MyEducation.jsx';
import Languages from './components/sections/languages/Languages.jsx';
import GameDev from './components/sections/gamedev/GameDev.jsx';
import Tutoring from './components/sections/Tutoring.jsx';
import Youtube from './components/sections/Youtube.jsx';
import Contact from './components/sections/Contact.jsx';
import Software from './components/sections/software/Software.jsx';

function App() {
  return (
    <div>
    <header>
        <HeaderButton 
          url="https://leetcode.com/jakubbala/"
          text="LeetCode"
          image="M16.102 17.93l-2.697 2.607c-.466.467-1.111.662-1.823.662s-1.357-.195-1.824-.662l-4.332-4.363c-.467-.467-.702-1.15-.702-1.863s.235-1.357.702-1.824l4.319-4.38c.467-.467 1.125-.645 1.837-.645s1.357.195 1.823.662l2.697 2.606c.514.515 1.365.497 1.9-.038.535-.536.553-1.387.039-1.901l-2.609-2.636a5.055 5.055 0 0 0-2.445-1.337l2.467-2.503c.516-.514.498-1.366-.037-1.901-.535-.535-1.387-.552-1.902-.038l-10.1 10.101c-.981.982-1.494 2.337-1.494 3.835 0 1.498.513 2.895 1.494 3.875l4.347 4.361c.981.979 2.337 1.452 3.834 1.452s2.853-.512 3.835-1.494l2.609-2.637c.514-.514.496-1.365-.039-1.9s-1.386-.553-1.899-.039zM20.811 13.01H10.666c-.702 0-1.27.604-1.27 1.346s.568 1.346 1.27 1.346h10.145c.701 0 1.27-.604 1.27-1.346s-.569-1.346-1.27-1.346z"
          imageSize="24"
          />
        <HeaderButton 
          url="https://github.com/JakubBala"
          text="GitHub"
          image="M7.49936 0.850006C3.82767 0.850006 0.849976 3.8273 0.849976 7.50023C0.849976 10.4379 2.75523 12.9306 5.39775 13.8104C5.73047 13.8712 5.85171 13.6658 5.85171 13.4895C5.85171 13.3315 5.846 12.9135 5.84273 12.3587C3.99301 12.7604 3.60273 11.4671 3.60273 11.4671C3.30022 10.6988 2.86423 10.4942 2.86423 10.4942C2.26044 10.0819 2.90995 10.0901 2.90995 10.0901C3.57742 10.137 3.9285 10.7755 3.9285 10.7755C4.52167 11.7916 5.48512 11.4981 5.86396 11.3279C5.92438 10.8984 6.09625 10.6053 6.28608 10.4391C4.80948 10.2709 3.25695 9.70063 3.25695 7.15241C3.25695 6.42615 3.51618 5.83298 3.94157 5.368C3.87299 5.1998 3.64478 4.52375 4.00689 3.60807C4.00689 3.60807 4.56494 3.42926 5.83538 4.28941C6.36568 4.14204 6.93477 4.06856 7.50018 4.0657C8.06518 4.06856 8.63386 4.14204 9.16498 4.28941C10.4346 3.42926 10.9918 3.60807 10.9918 3.60807C11.3548 4.52375 11.1266 5.1998 11.0584 5.368C11.4846 5.83298 11.7418 6.42615 11.7418 7.15241C11.7418 9.70716 10.1868 10.2693 8.70571 10.4338C8.94412 10.6392 9.15681 11.045 9.15681 11.6655C9.15681 12.5542 9.14865 13.2715 9.14865 13.4895C9.14865 13.6675 9.26867 13.8745 9.60588 13.8095C12.2464 12.9282 14.15 10.4375 14.15 7.50023C14.15 3.8273 11.1723 0.850006 7.49936 0.850006Z"
          imageSize="15"
          />
        <HeaderButton 
          url="#contact-section"
          text="Contact Me"
          textId="contact-button"
          boldText="true"
          />
    </header>

    <div className="flex-centre">
      <div>
        <Banner/>
        <Section title="About Me">
          <AboutMe/>
        </Section>

        <SectionSplit/>

        <Section title="My Education">
          <MyEducation/>
        </Section>

        <SectionSplit/>

        <Section title="Programming Languages">
          <Languages/>
        </Section>

        <SectionSplit/>

        <Section title="Software Engineering">
          <Software/>
        </Section>

        <SectionSplit/>

        <Section title="Game Development" showThreshold={0.05}>
          <GameDev/>
        </Section>

        <SectionSplit/>

        <Section title="Tutoring">
          <Tutoring/>
        </Section>

        <SectionSplit/>

        <Section title="Youtube">
          <Youtube/>
        </Section>

        <SectionSplit/>

        <Section title="Contact" sectionId="contact-section">
          <Contact/>
        </Section>

        <SectionSplit/>

      </div>
    </div>
    </div>
  );
}

export default App;
